import React, { Component, PropTypes } from 'react';
import { Paper } from 'material-ui';
import { ThemeStore } from 'stores';
import { StoreOverviewActions } from 'actions';
import * as SvgIcons from 'components/Material/SvgIcons';
import Cover from 'components/Material/Cover';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import { Units, Shadow, Colors } from 'Css';
import { TagList } from 'components/Tags';
import Gift from 'Cio/Assets/Gift';

const css = oxygenCss({
  root: {
    padding: `${Units.base * 2}px 0`
  },

  detail: {
    flexGrow: 1,
    padding: '13px 21px',
    boxSizing: 'border-box',
    position: 'relative'
  },
  price: {
    padding: Units.base,
    flexGrow: 0,
    textAlign: 'right',
    fontSize: 14,
    lineHeight: '32px'
  },
  tags: {
    flexGrow: 0,
    padding: `0 ${Units.base}px`
  },
  header: {
    fontFamily: 'MaisonNeue-Demi',
    fontSize: 16,
    lineHeight: `26px`,
    letterSpacing: '0.1px',
    color: '#2A2A2A'
  },
  author: {
    fontFamily: 'MaisonNeue-Book',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1.67,
    letterSpacing: '0.1px',
    color: '#4E4E4E'
  },
  description: {
    fontSize: 14,
    fontFamily: 'MaisonNeue-Book',
    lineHeight: 1.43,
    letterSpacing: '0.1px',
    color: '#686868',
    ' UL': {
      margin: Units.base
    },
    ' OL': {
      margin: Units.base
    }
  },
  container: {
    // display: '-msFlexbox',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'stretch',
    padding: Units.base * 2,
    '@phone': {
      padding: Units.base,
      display: 'block'
    }
  },
  itemWrapper: {
    margin: Units.base,
    position: 'relative',
    boxSizing: 'border-box',
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.09)',
    backgroundColor: Colors.theme.Light.card,
    // display: '-msFlexbox',
    display: 'flex',
    flexDirection: 'column',
    '@tablet': {
      flex: '0 0 50%'
    },
    '@desktop': {
      flex: '0 0 370px'
    },
    cursor: 'pointer'
  },
  buyButton: {
    transition: 'all 0.25s ease',
    fontFamily: 'MaisonNeue-Demi',
    cursor: 'pointer',
    borderRadius: 3,
    backgroundColor: '#f04f4f',
    minWidth: 64,
    textAlign: 'center',
    padding: `0px 4px`,
    color: Colors.fullWhite,
    fontSize: 16,
    height: 40,
    lineHeight: '40px',
    letterSpacing: '0.6px',
    boxSizing: 'border-box',
    fontWeight: 500,
    ':hover': {
      boxShadow: '0 2px 0 0 #d64646',
      backgroundColor: '#ff5555'
    }
  },
  giftButton: {
    transition: 'all 0.25s ease',
    fontFamily: 'MaisonNeue-Demi',
    fontSize: 14,
    letterSpacing: '0.1px',
    cursor: 'pointer',
    minWidth: 64,
    textAlign: 'center',
    padding: `10px 4px`,
    color: '#646464',
    ':hover': {
      backgroundColor: 'rgba(255, 80, 80, 0.1)',
      borderRadius: 100,
      color: '#ff5555'
    }
  },
  buttonWrapper: {
    margin: Units.base,
    flexGrow: 1
  },
  giftButtonWrapper: {
    margin: Units.base,
    flexGrow: 0
  },
  packBadge: {
    position: 'absolute',
    top: Units.base * 1,
    left: Units.base,
    lineHeight: '24px',
    padding: `${Units.base / 2}px ${Units.base}px`,
    color: Colors.fullWhite,
    fontWeight: 500,
    '>SVG': {
      verticalAlign: 'middle'
    }
  },
  publicIcon: {
    position: 'absolute',
    top: Units.base,
    right: Units.base
  },
  buttonContainer: {
    flexGrow: 0,
    borderStyle: 'solid none none none',
    borderWidth: 1,
    borderColor: '#f0f0f0',
    display: 'flex'
  },
  giftIcon: {
    // margin: `0 ${Units.base}px`
  }
});

class StoreCards extends Component {
  static propTypes = {
    username: PropTypes.string,
    items: PropTypes.array,
    canIEdit: PropTypes.bool,
    themeColor: PropTypes.string,
    onTouchTapItem: PropTypes.func,
    cart: PropTypes.array
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  onTouchTap = storeItem => {
    const { onTouchTapItem } = this.props;
    if (onTouchTapItem) {
      onTouchTapItem(storeItem);
    } else {
      const { type, slug } = storeItem;
      StoreOverviewActions.findBySlug(type, slug);
    }
  };

  buyItem = (storeItem, event) => {
    StoreOverviewActions.addToCart(storeItem);
    event.preventDefault();
    event.stopPropagation();
  };

  giftItem = (storeItem, event) => {
    StoreOverviewActions.addToCart(storeItem, true);
    event.preventDefault();
    event.stopPropagation();
  };

  render() {
    const { items, canIEdit, themeColor, ownerName } = this.props;
    return (
      <div className={css.container}>
        {items.map(storeItem => {
          const {
            price,
            currency,
            type,
            id,
            name,
            public: isPublic
          } = storeItem;
          const coverImages = storeItem.coverImage;
          const coverImage =
            (coverImages.length && coverImages.length > 0 && coverImages[0]) ||
            {};
          return (
            <div
              className={css.itemWrapper}
              key={storeItem.type + '-' + id}
              onTouchTap={this.onTouchTap.bind(this, storeItem)}
            >
              <Cover
                height={240}
                backgroundColor={
                  (!canIEdit && ThemeStore.getColor(themeColor, 0.5)) ||
                  'rgba(0, 0, 0, 0.5)'
                }
                image={coverImage.id && coverImage.url}
              />
              {type === 2 && (
                <Paper
                  className={css.packBadge}
                  style={{ backgroundColor: ThemeStore.getColor(themeColor) }}
                >
                  <SvgIcons.ActionViewModule color={Colors.fullWhite} />
                  <FormattedMessage
                    message={this.context.getIntlMessage('store.packOf')}
                    count={storeItem.courses.length}
                  />
                </Paper>
              )}
              <div className={css.detail}>
                {canIEdit && isPublic ? (
                  <div className={css.publicIcon}>
                    <SvgIcons.ImageRemoveRedEye
                      color={'green'}
                      style={{ width: 32, height: 32 }}
                    />
                  </div>
                ) : null}
                <div className={css.header}>{name}</div>
                <div className={css.author}>{ownerName}</div>
                <div
                  className={css.description}
                  dangerouslySetInnerHTML={{ __html: storeItem.description }}
                />
              </div>
              <div className={css.tags}>
                <TagList tags={storeItem.tagsMap} />
              </div>
              <div className={css.buttonContainer}>
                {isPublic ? (
                  <div className={css.buttonWrapper}>
                    <div
                      onTouchTap={this.buyItem.bind(this, storeItem)}
                      className={css.buyButton}
                    >
                      <FormattedMessage
                        message={this.context.getIntlMessage('store.buyFor')}
                        price={
                          <FormattedNumber
                            style="currency"
                            currency={currency}
                            maximumFractionDigits={0}
                            minimumFractionDigits={0}
                            value={Math.round(price.discounted)}
                          />
                        }
                      />
                    </div>
                  </div>
                ) : null}
                {isPublic ? (
                  <div className={css.giftButtonWrapper}>
                    <div
                      onTouchTap={this.giftItem.bind(this, storeItem)}
                      className={css.giftButton}
                    >
                      <Gift className={css.giftIcon} />{' '}
                      {this.context.getIntlMessage('store.giftCourse')}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default StoreCards;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreCards.js